<template>
  <div role="banner" :class="stContentMenuClass" :style="stContentMenuStyle">
    <nav class="st-content-menu-fixed" :style="stContentMenuFixedStyle">
      <div class="navbar">
        <figure class="st-logo" itemprop="associatedMedia image" itemscope itemtype="http://schema.org/ImageObject" data-component="image">
          <a href="http://www.straitstimes.com/" target="_blank">
              <img id="short_logo" :src="getLogoPath('st-logo')" alt="Straitstimes logo" title="Straitstimes logo" />
              <img id="long_logo" :src="getLogoPath('straits-times-logo')" alt="Straitstimes logo" title="Straitstimes logo" />
            </a>
        </figure>
        <div class="st-external-section">
          <template v-if="hasMenu">
            <ul>
                <li v-for="(item,i) in menu" :key="i" :class="{'current': isCurrentPage(item.href)}">
                <a v-if="item.module==='no'" :href="item.href" :title="item.title" :alt="item.title">{{item.name}}</a>
                <router-link v-else :title="item.title" :to="item.href">{{item.name}}</router-link>
                </li>
            </ul>
          </template>
          <st-social-sharing-entry :colorTheme="socialButtonColorTheme" :hasMenu="hasMenu" class="st-social-sharing-entry"></st-social-sharing-entry>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import StSocialSharingEntry from './StSocialSharingEntry/index.vue'

export default {
  components: {StSocialSharingEntry},
  computed: Object.assign(mapState(['menu', 'header']), {
    hasMenu () {
      return this.menu && this.menu.length
    },
    gradientMode () {
      return this.header && (this.header.bannerimage || this.header.bannervideo || (this.header.position === 'fixed' && this.isTabletWidth))
    },
    isOverlapBanner () {
      return this.header && (this.header.bannerimage || this.header.bannervideo)
    },
    socialButtonColorTheme () {
      if (this.gradientMode) return 'light'
      return 'dark'
    },
    stContentMenuClass () {
      return {
        'st-content-menu': true,
        'gradient': this.gradientMode,
        'overlap': this.isOverlapBanner,
        'sticked': this.header && this.header.position === 'fixed',
        'scrolled': this.$window.scrollY > 0
      }
    },
    stContentMenuStyle () {
      const bgColor = this.header && this.header.bg
      return {
        backgroundColor: this.gradientMode && !this.isOverlapBanner ? bgColor : null
      }
    },
    stContentMenuFixedStyle () {
      return {
        position: this.header && this.header.position
      }
    },
    isTabletWidth () {
      return this.$window.innerWidth < 768
    }
  }),
  methods: {
    isCurrentPage (href) {
      const pageName = window.location.pathname.split('/').pop() || 'index.html'
      return pageName === href.trim()
    },
    getLogoPath (name) {
      return require(`images_base/${name}${this.gradientMode ? '-white' : ''}.svg`)
    }
  }
}
</script>

<style lang="scss">
.st-content-menu {
  position: relative;
  height: 40px;
  border-bottom: 1px solid #B4B4B4;

  @include breakpoint($d_menu_mobile) {
    height: 50px;

    .st-content-menu-fixed {
      height: 50px;
    }

    &:not(.gradient).sticked.scrolled .st-content-menu-fixed {
      box-shadow: 0px 1px 5px #B4B4B4;
    }
  }

  &.sticked .st-content-menu-fixed {
    position: fixed;
  }

  &.gradient {
    border-bottom: none;
    .st-content-menu-fixed {
      background-color: transparent;
      background-image: linear-gradient(to bottom, rgba(#000000, 0.4), rgba(#000000, 0));
      box-shadow: none;

      .navbar .st-external-section > ul li a {
        color: #FFFFFF;
      }
    }
  }

  &.overlap {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 99999;
  }

  .st-content-menu-fixed {
    background-color: #FFFFFF;
    left: 0;
    right: 0;
    z-index: 99999;
    height: 40px;
    box-sizing: border-box;
    padding: 0 $outerSpacingMobile;

    @include breakpoint($d_medium) {
      padding: 0 $outerSpacing;
    }

    &.scrolled {
      box-shadow: 0px 2px 2px #000000;
    }

    @include breakpoint($d_menu_mobile) {
      height: 50px;
    }

    .navbar {
      max-width: 1440px;
      margin: 0 auto;
      box-sizing: border-box;
      position: relative;

      .st-logo {
        display: inline-block;

        #long_logo {
          display: none;
          width: 240px;
          height: 23px;
          // padding-top: 9px;
          padding-top: 14px;

          @include breakpoint($d_menu_mobile) {
            // padding-top: 14px;
            display: block;
          }
        }

        #short_logo {
          display: block;
          width: 27px;
          height: 23px;
          padding-top: 8px;
          box-sizing: unset;

          @include breakpoint($d_menu_mobile) {
            display: none;
          }
        }
      }

      .st-external-section {
        position: absolute;
        right: 0;
        top: 0;
        display: table;
        white-space: nowrap;
        height: 40px;

        @include breakpoint($d_menu_mobile) {
          height: 50px;
        }

        & > * {
          display: table-cell;
          vertical-align: middle;
        }

        & > ul {
          display: none;

          @include breakpoint($d_menu_mobile) {
            display: table-cell;
          }

          li {
            display: inline-block;
            margin-bottom: 0;
            text-align: center;
            font-size: 14px;
            text-transform: uppercase;
            opacity: 0.5;

            a {
              padding: 0 15px;
              font-family: $font-CuratorRegular;
              line-height: 1.4;
              color: $black;
              text-transform: uppercase;
              cursor: pointer;
              border-bottom: none;
              text-decoration: none;
            }

            &.current {
              opacity: 1;

              a {
                cursor: default;
              }
            }
          }
        }

        & > .st-social-sharing-entry {
          & > * {
            vertical-align: middle;
          }
        }
      } // st-external-section
    }
  } // st-content-menu-fixed
} // st-content-menu
</style>
